import * as React from 'react';

import copy from 'copy-to-clipboard';

import { useTranslation } from '@crehana/i18n';
import Copy from '@crehana/icons/outline/Copy';
import TextLink from '@crehana/ui/dist/Buttons/TextLink';

const CouponCode: React.FC<
  React.PropsWithChildren<{ code: string | null }>
> = ({ code }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = React.useState(false);

  const onCopy = () => {
    setCopied(true);
    if (code) {
      copy(code);
    }

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <div
      className="mt-16 md:mt-24 h-40 sm:h-52 flex items-center justify-center"
      css={`
        border: 1px dashed #4b22f4;
      `}
    >
      <TextLink
        css={`
          @media (min-width: 768px) {
            font-size: 18px !important;
            line-height: 20px !important;
          }
        `}
        className="text-purple-main hover:text-purple-medium"
        label={copied ? t('COPY_CONFIRMATION', '¡Copiado!') : code || ''}
        leftIcon={
          !copied
            ? {
                component: Copy,
                size: 24,
              }
            : undefined
        }
        onClick={onCopy}
      />
    </div>
  );
};

export default CouponCode;
